import { Navigate } from "react-router-dom";
import { tokenStore } from "../api/axiosClient";
import { hasPermission, hasAnyPermission } from "./permissions";

/**
 * Route-level guard. Combines auth check (is there a token?) with a
 * permission check. Behavior:
 *   - Not authenticated → redirect to /login.
 *   - Authenticated but missing permission → redirect to /forbidden.
 *   - Otherwise → render children.
 *
 * Usage in AppRoutes:
 *   <Route
 *     path="/roles"
 *     element={
 *       <PermissionRoute code="roles.read">
 *         <RolesListPage />
 *       </PermissionRoute>
 *     }
 *   />
 */
export default function PermissionRoute({ code, anyOf, children }) {
  if (!tokenStore.getAccessToken()) {
    return <Navigate to="/login" replace />;
  }

  const allowed = code
    ? hasPermission(code)
    : Array.isArray(anyOf)
    ? hasAnyPermission(anyOf)
    : true; // no permission specified → just needs to be logged in

  if (!allowed) {
    return <Navigate to="/forbidden" replace />;
  }

  return children;
}